import API from "./API"

export const getPriceLists = async() => {
    return await API.get('/price-lists')
  }